import React, { useMemo, useState } from 'react';
import {
	DocumentationFile,
	useDocumentationFilesQuery,
} from '../../../../graphql/graphql';
import { useAppContext } from '../../../../Services/AppContext';
import Loading from '../../../BaseModule/Components/Loading';
import { DocumentationFileAntivirusResult } from '../../Enums/DocumentationFileAntivirusResult.enum';
import Text from '../../../BaseModule/Components/Text';
import { PreviewFile } from '../../../Utils/MediaViewer/MediaViewer';
import { prepareDocumentationFileForMediaViewer } from '../../../ECard/Services/eCardFile.service';
import MediaViewerModal from '../../../Utils/MediaViewer/MediaViewerModal';

interface Props {
	documentationFileId: string;
	className?: string;
}

const DocumentationFilePreview: React.FC<Props> = ({
	documentationFileId,
	className,
}) => {
	const { data, isLoading } = useDocumentationFilesQuery({
		fileIds: [documentationFileId],
	});
	const { socketUrl } = useAppContext();
	const [isPreviewOpen, setIsPreviewOpen] = useState(false);

	const file: DocumentationFile | undefined = useMemo(() => {
		return data?.documentationFiles?.data?.[0] as DocumentationFile;
	}, [data]);

	const previewFile: PreviewFile | undefined = useMemo(() => {
		if (file) {
			return prepareDocumentationFileForMediaViewer(file, socketUrl);
		}
		return undefined;
	}, [file]);

	if (!file) {
		return <></>;
	}

	switch (file.avResult) {
		case DocumentationFileAntivirusResult.UNPROCESSED:
			return <Loading purple />;
		case DocumentationFileAntivirusResult.INFECTED:
			return <Text tx='base.shared.fileDidntPassAntivirus' />;
		case DocumentationFileAntivirusResult.CLEAN:
			return (
				<>
					<img
						className={className}
						src={file.thumbUrl}
						alt={file.displayName}
						onClick={() => setIsPreviewOpen(true)}
					/>
					{isPreviewOpen && previewFile && (
						<MediaViewerModal
							file={previewFile}
							onClose={() => setIsPreviewOpen(false)}
							opened
						/>
					)}
				</>
			);
	}

	return <></>;
};

export default DocumentationFilePreview;
